export const CarrierTypeOptions = [
    { value: 'company', label: 'Company' },
    { value: 'individual', label: 'Individual' },
];

export const CarrierCategories = [
    { value: 'carrier', label: 'Carrier' },
    { value: 'warehouse', label: 'Warehouse' },
    { value: 'logisticCompany', label: 'Logistic company' },
];

export const SubcontractorVerificationStatuses = {
    verified: {
        title: 'Verified',
        icon: 'ri-checkbox-circle-fill',
    },
    verifying: {
        title: 'Verifying',
        icon: 'ri-time-line',
    },
    unknown: {
        title: 'Unknown',
        icon: 'ri-question-line',
    },
};

export const MockCarrierHeaderSubtitle = 'FTL, LTL, Stückgut, KEP';

/** Display order for overview header `activatedFunctions` from the API. */
export const ACTIVATED_FUNCTION_KEYS = [
    'CS',
    'CI',
    'RDM',
    'CM',
    'DNB',
    'EGD',
    'CSI',
    'ANM',
];

export const mapActivatedFunctionsForDisplay = (activatedFunctions) => {
    if (!activatedFunctions || typeof activatedFunctions !== 'object') {
        return [];
    }

    const knownKeys = ACTIVATED_FUNCTION_KEYS.filter(
        (key) => Object.prototype.hasOwnProperty.call(activatedFunctions, key)
    );

    const keysToRender = knownKeys.length
        ? knownKeys
        : Object.keys(activatedFunctions).sort();

    return keysToRender.map((key) => ({
        key: key.toLowerCase(),
        label: key,
        active: !!activatedFunctions[key],
    }));
};

export const CarrierStatuses = {
    'Onboarding': {
        title: 'Onboarding',
        icon: 'ri-time-line',
        className: 'badge-soft-warning',
    },
    'Pending Review': {
        title: 'Pending Review',
        icon: 'ri-record-circle-line',
        className: 'badge-soft-info',
    },
    'Active': {
        title: 'Active',
        icon: 'ri-checkbox-circle-fill',
        className: 'badge-soft-success',
    },
    'Rejected': {
        title: 'Rejected',
        icon: 'ri-close-circle-fill',
        className: 'badge-soft-danger',
    },
};

export const OnboardingStageStates = {
    completed: {
        title: 'Completed',
        icon: 'ri-checkbox-circle-fill',
        className: 'text-success',
    },
    attention: {
        title: 'Attention required',
        icon: 'ri-error-warning-fill',
        className: 'text-warning',
    },
    not_completed: {
        title: 'Not completed',
        icon: 'ri-indeterminate-circle-line',
        className: 'text-muted',
    },
    failed: {
        title: 'Failed',
        icon: 'ri-close-circle-fill',
        className: 'text-danger',
    },
};

export const CarrierSummaryWidgets = {
    total: {
        icon: 'ri-group-line',
        color: 'primary',
    },
    active: {
        icon: 'ri-checkbox-circle-line',
        color: 'success',
    },
    onboarding: {
        icon: 'ri-time-line',
        color: 'info',
    },
    review: {
        icon: 'ri-record-circle-line',
        color: 'warning',
    },
    rejected: {
        icon: 'ri-close-circle-line',
        color: 'danger',
    },
};